<template>
  <div :class="defaultclass" role="alert" v-if="error">
    <table class="w100">
      <tr>
        <td v-if="messageKey">
          {{$t(messageKey)}}
          <template v-if="fncb">({{dataObject[dataKey]}})</template>
        </td>
        <td v-if="!messageKey">
          {{$t('NavDataDiffDisplayer.message')}}
          <template v-if="fncb">({{dataObject[dataKey]}})</template>
        </td>
        <td class="w1" v-if="fncb">
          <button type="button" id="navGetDetails" class="btn btn-primary btn-sm" v-on:click="callCb">
            <i class="fa fa-dot-circle-o"></i> {{$t('global.copy')}}
          </button>
        </td>
      </tr>
    </table>

  </div>
</template>
<script>

  import Api from '@/api/Api';
  import Helper from '@/helper/Helper';
  import SettingsContainer from '@/helper/SettingsContainer';

  export default {
    name: 'NavDataDiffDisplayer',
    mounted() {
      console.log("NavDataDiffDisplayer");
      const modul = this;
      modul.init();
//      modul.$eventBus.$on('globalSetBusinessPartner', this.globalSetBusinessPartnerEventHandler);
    },
    beforeDestroy() {
//      this.$eventBus.$off('globalSetBusinessPartner');
    },
    data() {
      return {
        dataObject: {},
        error: false,
      }
    },
    watch: {
      dataObjectStr: function (newValue, oldValue) {
        const modul = this;
        try {
          modul.dataObject = JSON.parse(newValue);
          modul.work();
        } catch (e) {
        }
      },
      dataKey: function (newValue, oldValue) {
        const modul = this;
        modul.work();
      },
      value: function (newValue, oldValue) {
        const modul = this;
        modul.work();
      },
      defaultclass: function (newValue, oldValue) {
        const modul = this;
        modul.work();
      },

    },

    props: {
      dataKey: {
        type: String,
        default: ''
      },
      value: { // data
        type: [String, Number],
        default: ''
      },
      dataObjectStr: { // nav object
        type: String,
        default: ""
      },
      defaultclass: {
        type: String,
        default: 'alert alert-danger'
      },
      irrelevantCapitalized: {
        type: String,
        default: 'false'
      },
      messageKey: {
        type: String,
        default: ''
      },
      fncb: {
        type: Function,
        default: function (event) {
        }
      },
    },
    methods: {
      init(){
        const modul = this;
        try {
          modul.dataObject = JSON.parse(modul.dataObjectStr);
          modul.work();
        } catch (e) {
          modul.work();
        }
      },
      callCb(){
        const modul = this;
        if (typeof modul.fncb === "function") {
          modul.fncb(modul.dataKey);
        }
      },
      work(){
        const modul = this;
        const key = modul.dataKey;
        const value = modul.value; // (modul.dataElement[key])?modul.dataElement[key]:void 0;
        const dataobject = modul.dataObject;

        if (key === "bank_account") {
          console.log("----bank_account----")
        }
        modul.error = false;
        if (typeof dataobject === "object" && dataobject !== null) {
          if (Object.keys(dataobject).length !== 0) {
            if (modul.irrelevantCapitalized === "true" && typeof dataobject[key] === "string" && dataobject[key].toLowerCase().trim() !== value.toLowerCase().trim()) {
              modul.error = true;
            } else if (typeof dataobject[key] === "string" && dataobject[key] !== value) {
              modul.error = true;
            } else if (typeof dataobject[key] === "number" && Number(dataobject[key]) !== Number(value)) {
              modul.error = true;
            }
          }
        }
      },
    },
    components: {},
  };
</script>
